module.exports = __webpack_public_path__ + "images/amazon-echo-alexa.jpg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/amazon-echo-alexa.jpg
// module id = 851
// module chunks = 0